export interface HeatmapData {
  [bucket: string]: number
}

export async function sendWatchEvents(videoId: string, buckets: number[]): Promise<boolean> {
  try {
    const response = await fetch(`/api/videos/${videoId}/watch_events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ buckets }),
    })
    return response.ok
  } catch {
    return false
  }
}

export async function fetchHeatmap(videoId: string): Promise<HeatmapData | null> {
  try {
    const response = await fetch(`/api/videos/${videoId}/watch_events`)
    if (!response.ok) return null
    const data = await response.json()
    return data.heatmap || {}
  } catch {
    return null
  }
}
